/**
 * Canonical form for account emails. Cognito usernames are case-sensitive, so any
 * signup/login/invite path that skips this can mint a duplicate identity
 * (e.g. DRELONG56@YAHOO.COM vs drelong56@yahoo.com).
 */
export function normalizeEmail(email: string): string;
export function normalizeEmail(
  email: string | null | undefined,
): string | null | undefined;
export function normalizeEmail(email: string | null | undefined) {
  return typeof email === 'string' ? email.trim().toLowerCase() : email;
}

export default normalizeEmail;
